module.exports = __webpack_public_path__ + "img/bg-edu.69690633.jpg";